import Input from '../../common/formElements/Input';
import Textarea from '../../common/formElements/Textarea';
import formFields from './formFields';

const Form = ({ formDetails, onFormUpdate, errors }) => {
  return (
    <>
      {formFields.map((field) => {
        if (field.type === 'textarea') {
          return (
            <div key={field.category} className="form-group mb-3">
              <Textarea
                value={formDetails[field.category]}
                placeholder={field.placeholder}
                onChange={e => onFormUpdate(field.category, e.target.value)}
              />
              {errors[field.category] && (
                <p className="text-danger">{errors[field.category]}</p>
              )}
            </div>
          );
        } else {
          return (
            <div key={field.category} className="form-group mb-3">
              <Input
                type={field.type}
                value={formDetails[field.category]}
                placeholder={field.placeholder}
                onChange={e => onFormUpdate(field.category, e.target.value)}
                errors={errors}
              />
              {errors[field.category] && (
                <p className="text-danger">{errors[field.category]}</p>
              )}
            </div>
          );
        }
      })}
    </>
  );
};

export default Form;
